//
// scheduler-service.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/*global angular: false, _ */

(function() {
    'use strict';

    angular.module('curalate').
        service('SchedulerService', ['$http', '$upload', 'PromiseService', 'RestBaseUrl',
            function($http, $upload, PromiseService, RestBaseUrl) {
                var formatDate, bufferItemsUrlParams;

                this.addSavedImageUrlAsync = function(imageUrl, sourceUrl, description, productsList, universalItemId, videoId) {
                    return this.addSavedImageUrlAsyncEx({
                        imageUrl: imageUrl,
                        sourceUrl: sourceUrl,
                        videoId: videoId,
                        description: description,
                        productsList: productsList,
                        universalItemId: universalItemId
                    });
                };

                this.addSavedImageUrlAsyncEx = function(params) {
                    return PromiseService.processHttpResponse($http.post(RestBaseUrl + '/publish/saved-images', params));
                };

                this.addSavedImageAsync = function(image) {
                    return PromiseService.processHttpResponse($upload.upload({
                        url: RestBaseUrl + '/publish/saved-images',
                        method: 'POST',
                        file: image
                    }));
                };

                this.getSavedImagesAsync = function(params) {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/saved-images', { params: params }));
                };

                this.getSavedImagesByIdAsync = function(itemIds) {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/saved-images/' + itemIds.join(',')));
                };

                this.getSavedImageProductsAsync = function(itemId) {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/saved-image-products/' + itemId));
                };

                this.copySavedImageAsync = function(existingImageId) {
                    return PromiseService.processHttpResponse($http.post(RestBaseUrl + '/publish/saved-images/' + existingImageId));
                };

                this.updateSavedImageAsync = function(itemId, data) {
                    return PromiseService.processHttpResponse($http.put(RestBaseUrl + '/publish/saved-images/' + itemId, data));
                };

                this.removeSavedImageAsync = function(itemId) {
                    return PromiseService.processHttpResponse($http.delete(RestBaseUrl + '/publish/saved-images/' + itemId));
                };

                this.getProcessingVideos = function() {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/processing-videos'));
                };

                this.getBoardsAsync = function(refresh) {
                    var params = {};
                    if (refresh) {
                        params.refresh = refresh;
                    }

                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/pinterest-boards', { params: params }));
                };

                this.getBuffersAsync = function() {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/buffers'));
                };

                this.getBufferAsync = function(bufferId) {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/buffers/' + bufferId));
                };

                this.addBufferAsync = function(data) {
                    return PromiseService.processHttpResponse($http.post(RestBaseUrl + '/publish/buffers', data));
                };

                this.updateBufferAsync = function(bufferId, data) {
                    return PromiseService.processHttpResponse($http.put(RestBaseUrl + '/publish/buffers/' + bufferId, data));
                };

                this.reorderScheduleItemsAsync = function(bufferId, data) {
                    return PromiseService.processHttpResponse($http.put(RestBaseUrl + '/publish/buffers/' + bufferId + '/buffer-items/order', data));
                };

                this.removeBufferAsync = function(bufferId) {
                    return PromiseService.processHttpResponse($http.delete(RestBaseUrl + '/publish/buffers/' + bufferId));
                };

                this.getAllBufferItemsAsync = function(params) {
                    var params = bufferItemsUrlParams(params);
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/buffer-items', { params: params }));
                };

                this.getAllBufferItemsExportUrl = function(params) {
                    var params = bufferItemsUrlParams(params),
                        paramString = "",
                        isFirstParam = true;

                    _.mapObject(params, function(val, key) {
                        var delimiter = isFirstParam ? "?" : "&";
                        isFirstParam = false;

                        paramString += delimiter + encodeURIComponent(key) + "=" + encodeURIComponent(val);
                    });

                    return '/api/publish/buffer-items.csv' + paramString;
                };

                this.countAllBufferItemsForDateRangeAsync = function(startDate, endDate) {
                    var formatDate = function(moment) {
                        return moment.format("YYYY-MM-DD");
                    };
                    var formattedDateRange = formatDate(startDate) + "_" + formatDate(endDate);
                    var params = {dateRange: formattedDateRange};
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/buffer-items-count', { params: params }));
                };

                this.scheduleAsync = function(bufferId, data) {
                    return PromiseService.processHttpResponse($http.post(RestBaseUrl + '/publish/buffers/' + bufferId + '/buffer-items', data));
                };

                this.updateBufferItemProductsAsync = function(bufferId, itemId, data) {
                    return PromiseService.processHttpResponse($http.put(RestBaseUrl + '/publish/buffers/' + bufferId + '/buffer-items/' + itemId + '/products', data));
                };

                this.updateScheduleAsync = function(bufferId, itemId, data) {
                    return PromiseService.processHttpResponse($http.put(RestBaseUrl + '/publish/buffers/' + bufferId + '/buffer-items/' + itemId, data));
                };

                this.removeScheduleAsync = function(bufferId, itemId) {
                    return PromiseService.processHttpResponse($http.delete(RestBaseUrl + '/publish/buffers/' + bufferId + '/buffer-items/' + itemId));
                };

                this.addInstagramPostToLike2Buy = function(itemId) {
                    return PromiseService.processHttpResponse($http.post(RestBaseUrl + '/publish/add-to-like2buy/' + itemId));
                };

                this.generateAviarySignatureAsync = function() {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/publish/generate-aviary-signature'));
                };

                this.sendMobileInstallerLinkAsync = function(phoneNumber) {
                    return PromiseService.processHttpResponse($http.post(RestBaseUrl + '/publish/send-mobile-installer-link', {
                        phoneNumber: phoneNumber
                    }));
                };

                this.getMobileDevicesAsync = function() {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/mobile-devices'));
                };

                this.getTagsForImageAsync = function(fileId) {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/brand-tags', {
                        params: {
                            fileId: fileId
                        }
                    }));
                };

                this.getTimeZonesAsync = function() {
                    return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/time-zones'));
                };

                // In the post-square IG world, images can be non-square within bounds.
                // Tall images are limited to 4:5 width:height ratio, or 0.8
                // Wide images are limited to 19:10 width:height ratio, or 1.9
                this.instagramRatios = {
                    WIDTH_HEIGHT_RATIO_LOWER_BOUND: 0.8,
                    WIDTH_HEIGHT_RATIO_UPPER_BOUND: 1.9,
                    WIDTH_HEIGHT_RATIO_LOWER_BOUND_STRING: '4:5',
                    WIDTH_HEIGHT_RATIO_UPPER_BOUND_STRING: '19:10'
                };

                this.instagramVideoDuration = {
                    DURATION_MINIMUM_IN_MS: 3 * 1000 // 3 seconds
                };

                this.getForceCropRatio = function(item, dimensions) {
                    var isInstagram, widthHeightRatio;

                    isInstagram = item && item.buffer && item.buffer.network === 'Instagram';

                    // Only force a crop for Instagram. 
                    // If not for IG or dimensions aren't known, no cropping.
                    if (!isInstagram || !dimensions) {
                        return null;
                    }

                    widthHeightRatio = dimensions.naturalWidth / dimensions.naturalHeight;
                    // Acceptable ratios for IG images in the post-square world are 0.8 to 1.9 W/H ratio.
                    // If outside of these bounds, limit to the one that is surpassed.
                    if (widthHeightRatio < this.instagramRatios.WIDTH_HEIGHT_RATIO_LOWER_BOUND) {
                        return this.instagramRatios.WIDTH_HEIGHT_RATIO_LOWER_BOUND_STRING;
                    } else if (widthHeightRatio > this.instagramRatios.WIDTH_HEIGHT_RATIO_UPPER_BOUND) {
                        return this.instagramRatios.WIDTH_HEIGHT_RATIO_UPPER_BOUND_STRING;
                    } else {
                        // If we're in the goldilocks zone don't force any crops.
                        return null;
                    }
                };

                this.hasValidInstagramDimensions = function(dimensions, ratio) {
                    var widthHeightRatio;
                    if (dimensions) {
                        widthHeightRatio = dimensions.naturalWidth / dimensions.naturalHeight;
                    } else if (ratio) {
                        widthHeightRatio = ratio;
                    } else {
                        return true;
                    }

                    // Round to 1 decimal place
                    widthHeightRatio = Math.round(widthHeightRatio * 10) / 10;
                    return (widthHeightRatio >= this.instagramRatios.WIDTH_HEIGHT_RATIO_LOWER_BOUND) &&
                           (widthHeightRatio <= this.instagramRatios.WIDTH_HEIGHT_RATIO_UPPER_BOUND);
                };

                this.hasValidVideoDuration = function(duration) {
                    // TODO: when pinterest video support is added, expand this logic to include network distinctions
                    return duration > this.instagramVideoDuration.DURATION_MINIMUM_IN_MS;
                };

                formatDate = function(moment) {
                    if (moment !== undefined) {
                        return moment.format("YYYY-MM-DD");
                    } else {
                        return '';
                    }
                };

                bufferItemsUrlParams = function(params) {
                    var httpParams = {};

                    if (_.has(params, 'socialNetworks')) {
                        httpParams.socialNetworks = params.socialNetworks.join(',');
                    }

                    if (_.has(params, 'bufferIds')) {
                        httpParams.bufferIds = params.bufferIds.join(',');
                    }

                    if (_.has(params, 'startDate') || _.has(params, 'endDate')) {
                        httpParams.dateRange = formatDate(params.startDate) + '_' + formatDate(params.endDate);
                    }

                    if (_.has(params, 'offset')) {
                        httpParams.offset = params.offset;
                    }

                    if (_.has(params, 'limit')) {
                        httpParams.limit = params.limit;
                    }

                    if (_.has(params, 'scheduled')) {
                        httpParams.scheduled = params.scheduled;
                    }

                    if (_.has(params, 'includeNotified')) {
                        httpParams.includeNotified = params.includeNotified;
                    }

                    if (_.has(params, 'itemType')) {
                        httpParams.itemType = params.itemType;
                    }

                    return httpParams;
                };
            }
        ]);
})();
